module.exports = __webpack_public_path__ + "img/join3-3.0b1c4e05.svg";